var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CourseList"},[_c('AppHeader',{attrs:{"content":"课程管理 | 课程列表"}}),_c('AppBox',{staticClass:"appBox"},[_c('CourseTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }